@if (!loadComplete()) {
  <is-wait-message [loadComplete]="loadComplete()" [useBolt]="false" [waitMessage]="'Please wait while we process your request.'" [timeoutAmount]="0"></is-wait-message>
} @else {
  @if (addRefundMethodFormGroup) {
    <form [formGroup]="addRefundMethodFormGroup.group" class="manage-payment-form-container" (ngSubmit)="navigateToReview()">
      <div class="bolt-container">
        <bolt-progress-bar appFocusOnInit arialabel="add refund method progress value is 33%" class="progress-bar-container to-container" value="33"></bolt-progress-bar>
        <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Add refund method</h1>
        <div class="bolt-row">
          <div class="bolt-col-12">
            @if (isPageLevelError) {
              <bolt-notification type="error" [id]="'global-error-message'" appFocusOnInit class="bolt-space-bottom-xl to-container">
                Please check the information below and try again.
              </bolt-notification>
            }
            @if (canDisplayAccountInfoHeader) {
              <app-payment-sub-header>Account information</app-payment-sub-header>
            }
            <div class="bolt-space-bottom-lg">
              <app-payment-method-section
                [hasDefaultMethod]="hasDefaultMethod(savedPaymentMethods)"
                [hasSavedPaymentMethod]="hasSavedPaymentMethod(savedPaymentMethods)"
                [(selectedPaymentMethod)]="selectedPaymentMethod"></app-payment-method-section>
            </div>
          </div>
        </div>
      </div>
      <bolt-button-bar>
        <bolt-button slot="cancel" aria-label="cancel" id="cancel-button" (click)="navigateToPaymentPreferences()">Cancel</bolt-button>
        <bolt-button submit [disabled]="selectedPaymentMethod?.isPlaceholder" slot="forward" type="primary submit" aria-label="continue" id="continue-button">Continue</bolt-button>
      </bolt-button-bar>
    </form>
  }
}
